import css from 'styled-jsx/css'

type OrdLineQuantityProp = {
  orderLine: Types.OrderLine
}

export const OrdLineQuantity = ({ orderLine }: OrdLineQuantityProp) => {
  return (
    <>
      <style jsx>{compStyle}</style>
      <div className="pt-2">
        {/* order line */}
        <div className="do-detail__property">
          <div className="quantity-variant-box mr-4">
            <span className="quantity-variant-box__num">{orderLine?.quantity} </span>
          </div>
          <div>
            <span className="mr-4">x</span>
          </div>
          <div>
            {orderLine.variant_properties?.map((property, index) => (
              <span key={index}>
                <span className="mr-4">
                  <strong>{property.name}</strong>: {property.value}
                </span>
                {(orderLine.variant_properties ?? []).length - 1 != index && (
                  <span className="mr-4"> | </span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
    </>
  )
}

const compStyle = css`
  .quantity-variant-box {
    border: 1px solid #e0e3e9;
    border-radius: 5px;
    padding: 4px 10px;
    min-width: 30px;
    min-height: 30px;

    &__num {
      height: 20px;

      padding: 3px;

      font-weight: 600;
      font-size: 14px;
      line-height: 20px;

      display: flex;
      align-items: center;
      text-align: center;
    }
  }

  .do-detail {
    p {
      font-size: 12px;
      line-height: 24px;
      max-width: 250px;
      margin-bottom: auto;
    }

    &__property {
      display: flex;
      align-items: center;
      margin-bottom: 16px;

      img {
        width: 48px;
        height: 48px;
        border: 1px solid #e8e8e8;
        box-sizing: border-box;
        border-radius: 4px;
      }

      &--quality {
        font-size: 16px;
        line-height: 32px;
        font-weight: 600;
        white-space: nowrap;
      }
    }
  }
`
